import { UPDATE_FRONT_STYLE_LVZ } from "./frontStyleLvzReducer"

export const updateFrontStyleLvz = (status) => ({
    type: UPDATE_FRONT_STYLE_LVZ,
    payload: status
})
